class LuxCollectionPagination extends HTMLElement {
    constructor() {
        super();
        this.loaderButton = this.querySelector('.lux-collection-pagination__loader-button');
        this.statusContainer = this.querySelector('.lux-collection-pagination__loader-status');
        this.progressBarInner = this.querySelector('.lux-collection-pagination__progress-bar--inner');
        this.progressStatusText = this.querySelector('.lux-collection-pagination__progress-status');
        
        // Target spans for live updates
        this.visibleCountSpan = this.querySelector('.lux-collection-pagination__loader-status--page');
        this.remainingCountSpan = this.querySelector('.lux-collection-pagination__loader-status--remaining');
    }

    connectedCallback() {
        if (this.loaderButton) {
            this.loaderButton.addEventListener('click', () => this.loadMoreProducts());
        }
    }

    async loadMoreProducts() {
        // Find the "Next" link URL from the existing pagination list
        const nextLink = this.querySelector('a.directional[href*="page"]:last-of-type');
        if (!nextLink || nextLink.classList.contains('is-disabled')) return;

        this.loaderButton.disabled = true;
        this.loaderButton.textContent = 'Učitavanje...';

        try {
            const response = await fetch(nextLink.href);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // 1. Append New Products
            const sourceItems = doc.querySelectorAll('.lux-collection-grid__items .lux-collection-product');
            const targetGrid = document.querySelector('.lux-collection-grid__items');
            
            sourceItems.forEach(item => targetGrid.appendChild(item));

            // 2. Update Pagination State (URL and visibility)
            const newPagination = doc.querySelector('lux-collection-pagination');
            if (newPagination) {
                this.innerHTML = newPagination.innerHTML;
                // Re-bind the click event to the new button since innerHTML replaced it
                this.loaderButton = this.querySelector('.lux-collection-pagination__loader-button');
                this.loaderButton.addEventListener('click', () => this.loadMoreProducts());
                
                // Update the counters and progress bar
                this.refreshUI(targetGrid.querySelectorAll('.lux-collection-product').length);
            }
        } catch (error) {
            console.error('Pagination Error:', error);
        } finally {
            if (this.loaderButton) {
                this.loaderButton.disabled = false;
                this.loaderButton.textContent = 'Prikaži još proizvoda';
            }
        }
    }

    refreshUI(currentVisible) {
        const total = parseInt(this.querySelector('.lux-collection-pagination__loader-status').dataset.productsTotal);
        const remaining = Math.max(0, total - currentVisible);
        const progressPercent = Math.round((currentVisible / total) * 100);

        // Update Counter Text
        const vSpan = this.querySelector('.lux-collection-pagination__loader-status--page');
        const rSpan = this.querySelector('.lux-collection-pagination__loader-status--remaining');
        if (vSpan) vSpan.textContent = currentVisible;
        if (rSpan) rSpan.textContent = remaining;

        // Update Progress Bar
        const bar = this.querySelector('.lux-collection-pagination__progress-bar--inner');
        const status = this.querySelector('.lux-collection-pagination__progress-status');
        if (bar) bar.style.setProperty('--progress', `${progressPercent}%`);
        if (status) status.textContent = `${progressPercent}%`;

        // Remove button if done
        if (remaining === 0) {
            this.querySelector('.lux-collection-pagination__loader').style.display = 'none';
        }
    }
}

if (!customElements.get('lux-collection-pagination')) {
    customElements.define('lux-collection-pagination', LuxCollectionPagination);
}